module.exports = __webpack_public_path__ + "img/8.333b87f8.jpg";